const initialState = {
    fetching: false,
    fetchingLists: false,
    fetchingFollowing: false,
    user: {
        displayName: null,
        emailAddress: null,
        interests: [],
        tags: [],
        usertype: 'guest',
    },
    lists: [],
    following: [],
    followers: [],
    likedListIds: [],
    likedProductIds: [],
    likedArticleIds: [],
    error: null,
    signedUpForEmails: false,
};

export default function self(state = initialState, action) {
    switch (action.type) {
        case 'REQUEST_SELF':
            return {
                ...state,
                fetching: true,
            };
        case 'CLEAR_SELF':
            return initialState;
        case 'RECEIVE_SELF':
            return {
                ...state,
                user: {
                    ...action.user,
                },
                lists: [],
                following: [],
                fetching: false,
            };
        case 'UPDATE_SELF':
            return {
                ...state,
                user: action.user,
                wasEdited: true,
            };
        case 'REQUEST_SELF_LISTS':
            return {
                ...state,
                fetchingLists: true,
            };
        case 'RECEIVE_SELF_LISTS':
            return {
                ...state,
                lists: action.lists,
                fetchingLists: false,
            };
        case 'REQUEST_SELF_FOLLOWING':
            return {
                ...state,
                fetchingFollowing: true,
            };
        case 'RECEIVE_SELF_FOLLOWING':
            return {
                ...state,
                following: action.following,
                fetchingFollowing: false,
            };
        case 'RECEIVE_SELF_FOLLOWERS':
            return {
                ...state,
                followers: action.followers,
                fetchingFollowers: false,
            };
        case 'SET_SELF_ERROR':
            return {
                ...state,
                error: action.error,
                fetching: false,
                fetchingLists: false,
                fetchingFollowing: false,
            };
        case 'RECEIVE_SELF_LIKED_LIST_IDS':
            return {
                ...state,
                likedListIds: action.likedLists,
            };
        case 'RECEIVE_SELF_LIKED_PRODUCT_IDS':
            return {
                ...state,
                likedProductIds: action.likedProducts,
            };
        case 'RECEIVE_SELF_LIKED_ARTICLE_IDS':
            return {
                ...state,
                likedArticleIds: action.likedArticles,
            };
        case 'UPDATE_SELF_META':
            return {
                ...state,
                ...action.meta,
            };
        default:
            return state;
    }
}
